/**
 * @generated SignedSource<<22b96006de9665ec420b548cbef7a033>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Housing",
    "kind": "LinkedField",
    "name": "cmsHousing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Meta",
        "kind": "LinkedField",
        "name": "meta",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CmsImage",
        "kind": "LinkedField",
        "name": "picture1",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CmsImage",
        "kind": "LinkedField",
        "name": "picture2",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HousingRoom",
        "kind": "LinkedField",
        "name": "rooms",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CmsImage",
            "kind": "LinkedField",
            "name": "gallery",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingDescription",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HousingPageQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HousingPageQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4c00d7449a7dc25af90f2f4267e51219",
    "id": null,
    "metadata": {},
    "name": "HousingPageQuery",
    "operationKind": "query",
    "text": "query HousingPageQuery(\n  $slug: String\n) {\n  cmsHousing(slug: $slug) {\n    id\n    title\n    description\n    meta {\n      description\n    }\n    picture1 {\n      title\n      url\n    }\n    picture2 {\n      title\n      url\n    }\n    rooms {\n      title\n      description\n      gallery {\n        title\n        url\n      }\n    }\n    bookingDescription\n  }\n}\n"
  }
};
})();

node.hash = "ccf3f4ee99fbcad0bf9f1669b4f63ed4";

module.exports = node;
